
export class ModalError extends Error {
    constructor(code, details) {
        super(details);
        this.code = code;
        this.name = "ModalError";
    }
}